import * as React from 'react';

// Define the shape of your context data
export interface BannerContextData {
  hideBanner: () => void;
  showBanner: (props: unknown) => void;
}

export const Context = React.createContext<BannerContextData>({
  hideBanner: () => null,
  showBanner: (_props) => null,
});
